import { useState } from "react";
import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";
import "./DemoForm.scss";
import { MdEmail } from "react-icons/md";
import { IoCallSharp } from "react-icons/io5";
import { GoAlert } from "react-icons/go";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import TextError from "../../partnerWithUs/partnerForm.jsx/texterror/TextError";
import axios from "axios";
import { baseUrl, storeContact } from "../../../utils/apiData";

const DemoForm = ({ data }) => {
  const [loader, setLoader] = useState(false);
  const [viewMsg, setViewMsg] = useState(false);

  const [formError, setFormError] = useState(false);

  const contactApi = async (values) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${storeContact}`, { ...values });
      if (res?.data?.success) {
        setLoader(false);
        setViewMsg(true);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
      setFormError(true);
      setTimeout(() => {
        setFormError(false);
      }, 5000);
    }
  };

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    discover_farsight: "",
    intrested_in: "",
    message: "",
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("Field is required!"),
    last_name: Yup.string().required("Field is required!"),
    phone_number: Yup.string().required("Field is required!"),

    email: Yup.string()
      .email("Invalid email formate!")
      .required("Email is required!"),
    discover_farsight: Yup.string().required("Field is required!"),
    intrested_in: Yup.string().required("Field is required!"),
    message: Yup.string().required("Field is required!"),
  });

  const onSubmit = (values, { resetForm }) => {
    contactApi(values);
    resetForm();
  };

  return (
    <section className="demo_form">
      <div className="content_wrap p_top">
        <div className="info">
          <p className="t-16 wow fadeInUp">
            <b>Address:</b>
            <br />
            {data?.address}
          </p>
          <a href={`tel:${data?.number}`}>
            <IoCallSharp />
            {data?.number}
          </a>
          <a href={`mailto:${data?.email}`}>
            <MdEmail />
            {data?.email}
          </a>
        </div>
        <div className="form_wrap ">
          {viewMsg ? (
            <div className="msg_wrap p_bottom">
              <h2>
                Thank you for reaching out! Our team will get back to you soon.
              </h2>
            </div>
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              <Form>
                <h3>Book Your Live Demo</h3>
                <div className="bi_field">
                  <div className="input_field wow fadeInUp">
                    <label>First Name*</label>
                    <Field
                      type="text"
                      placeholder="Enter First Name"
                      id="first_name"
                      name="first_name"
                    />
                    <ErrorMessage name="first_name" component={TextError} />
                  </div>

                  <div
                    className="input_field wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    <label>Second Name*</label>
                    <Field
                      type="text"
                      placeholder="Enter Last Name"
                      id="last_name"
                      name="last_name"
                    />
                    <ErrorMessage name="last_name" component={TextError} />
                  </div>
                </div>

                <div className="bi_field">
                  <div className="input_field wow fadeInUp">
                    <label>Company Email*</label>
                    <Field
                      type="email"
                      placeholder="Enter Email"
                      id="email"
                      name="email"
                    />
                    <ErrorMessage name="email" component={TextError} />
                  </div>
                  <div className="input_field wow fadeInUp">
                    <label>Phone Number</label>
                    <Field
                      type="number"
                      placeholder="Enter Phone Number"
                      id="phone_number"
                      name="phone_number"
                    />
                    <ErrorMessage name="phone_number" component={TextError} />
                  </div>
                </div>
                <div className="input_field wow fadeInUp">
                  <label>How did you discover Farsight?*</label>
                  <Field
                    type="text"
                    placeholder="How You Found Us?"
                    id="discover_farsight"
                    name="discover_farsight"
                  />
                  <ErrorMessage
                    name="discover_farsight"
                    component={TextError}
                  />
                </div>

                <div className="input_field wow fadeInUp">
                  <label>I'm interested in being a*</label>
                  <Field as="select" name="intrested_in" id="intrested_in">
                    <option value="" label="- Select -" disabled />
                    <option value="vendor" label="Vendor" />
                    <option value="partner" label="Partner" />
                    <option value="enduser" label="End user" />
                  </Field>
                  <ErrorMessage name="intrested_in" component={TextError} />
                </div>

                <div className="input_field wow fadeInUp">
                  <label>What would you like to discuss?</label>
                  <Field as="textarea" id="message" name="message" />
                  <ErrorMessage name="message" component={TextError} />
                </div>

                <ArrowBtn
                  text={loader ? "Loading..." : "Submit"}
                  theme="secondary_ternery"
                  classList="wow fadeInUp"
                  type="submit"
                  handleClick={() => {}}
                />
                {formError && (
                  <p className="error mt-2">
                    <GoAlert />
                    Something went wrong!
                  </p>
                )}
              </Form>
            </Formik>
          )}
        </div>
      </div>
    </section>
  );
};

export default DemoForm;
